import React from 'react';
import { Form } from 'react-bootstrap';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export function EmployeeActivityTotalsRow(_ref) {
  let {
    claim
  } = _ref;
  const claimEmployeeTotalSalary = Number(claim.employee_wage_totals).toString();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 3 + (claim.claim_group.project_methodology === 'project_basis' ? 2 * claim.claim_group.claim_project_reports.length : 0)
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '70pt',
      maxWidth: '70pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    object: claim,
    disabled: true,
    name: "employees_weighted_rnd",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: {
      ...claim,
      claim_employee_total_salary: claimEmployeeTotalSalary
    },
    disabled: true,
    name: "employee_wage_totals",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_qualifying_rnd_expenditure",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null)));
}